var exports = {
  "k": "xa15a2ab7--0b4d07--container",
  "Q": "xa15a2ab7--0b4d07--content",
};

module.exports = exports;
